import { defineStore } from "pinia"
import { ref } from "vue"
import UtilService from "@/services/resources/UtilService"
import { useAuthStore } from "@/store/auth.store"
import { useConfigStore } from "@/store/config.store"

const serviceUtilService = UtilService.build()

export const useAppStore = defineStore('app', () => {
  // State
  const loaded = ref(false)
  const modals = ref<unknown[]>([])
  let loading: Promise<void> | null = null

  // Actions
  // VSUS-1754: so marca como carregado quando as settings foram de fato buscadas.
  // Sem sessao (ex.: App montado em /sign-in), deixa para a proxima chamada,
  // feita pelo middleware authentication apos o login sem reload.
  async function actionLoad() {
    if (loaded.value) {
      return
    }
    if (!loading) {
      loading = actionLoadMetas()
        .then((fetched) => {
          if (fetched) loaded.value = true
        })
        .finally(() => {
          loading = null
        })
    }
    await loading
  }

  async function actionUnload() {
    loaded.value = false
  }

  async function actionLoadMetas(): Promise<boolean> {
    try {
      const authStore = useAuthStore()
      if (authStore.getMemberId() && authStore.getSiteId()) {
        await useConfigStore().actionFetchSettings()
        return true
      }
    } catch (error) {
      console.error(error)
    }
    return false
  }

  async function actionCheckUrlEmbed(payload: { url: string }) {
    return serviceUtilService.read(`/check-embed?url=${payload.url}`)
  }

  return {
    // State
    loaded,
    modals,

    // Actions
    actionLoad,
    actionUnload,
    actionLoadMetas,
    actionCheckUrlEmbed,
  }
})
